module.exports = __webpack_public_path__ + "static/media/SHBI.21a192d6.png";